module.exports = "/_next/static/images/a714350f13f425dbc563e5f8da3c43d6-pregnant-woman@desktop@2x.jpg";